import {HostApplicationStoreType} from 'hostApplicationStoreType';

/**
 * Returns if the auth popup is open
 */
export const getIsPopupOpen = (store: HostApplicationStoreType) => store.authPopup?.visible;
